import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreClients } from "../../api/apiClients";
import parseError from "../../utils/parseError";

/**
 * Hook لاستعادة جماعية للعملاء
 */
export function useRestoreAllClients() {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllClientsMutate,
        isPending,
    } = useMutation({
        mutationFn: massRestoreClients,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["clients"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore clients");
        },
    });

    return {
        restoreAllClientsMutate,
        isPending,
    };
}